// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UKfo","type":"styles_type__2swvP","choices":"styles_choices__GVbcu"};